import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  TablePagination,
  Tooltip,
  TableSortLabel,
} from '@mui/material';
import { Edit, Delete, Description } from '@mui/icons-material';
import useSortTable from '../../../hooks/useSortTable';

const TemplateTable = ({ templates, onEdit, onDelete, page, onPageChange, pagination, canEdit, canDelete }) => {
  const { sorted, sortBy, sortDir, handleSort } = useSortTable(templates);

  if (!templates || templates.length === 0) {
    return (
      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <Description sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
        <p>No hay plantillas registradas</p>
      </Paper>
    );
  }

  const handleChangePage = (event, newPage) => {
    onPageChange(newPage + 1);
  };

  const truncateText = (text, maxLength = 100) => {
    if (!text) return '-';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  const SortCell = ({ label, field, sx: extraSx }) => (
    <TableCell onClick={() => handleSort(field)} sx={{ cursor: 'pointer', userSelect: 'none', ...extraSx }}>
      <TableSortLabel active={sortBy === field} direction={sortBy === field ? sortDir : 'asc'}>
        {label}
      </TableSortLabel>
    </TableCell>
  );

  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <SortCell label="Título" field="title" />
              <SortCell label="Descripción" field="description" sx={{ display: { xs: 'none', sm: 'table-cell' } }} />
              <SortCell label="Empresa" field="company.name" sx={{ display: { xs: 'none', md: 'table-cell' } }} />
              <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Vista Previa</TableCell>
              <TableCell align="right">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sorted.map((template) => (
              <TableRow key={template.id} hover>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Description color="primary" />
                    <strong>{template.title}</strong>
                  </Box>
                </TableCell>
                <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{truncateText(template.description, 80)}</TableCell>
                <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                  {template.company ? (
                    <Box>
                      <div>{template.company.name}</div>
                      <small style={{ color: 'gray' }}>{template.company.short}</small>
                    </Box>
                  ) : (
                    '-'
                  )}
                </TableCell>
                <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                  <Box
                    sx={{
                      maxWidth: 300,
                      fontSize: '0.85rem',
                      color: 'text.secondary',
                      fontStyle: 'italic',
                    }}
                  >
                    {truncateText(template.content, 100)}
                  </Box>
                </TableCell>
                <TableCell align="right">
                  {canEdit && (
                    <Tooltip title="Editar">
                      <IconButton size="small" color="primary" onClick={() => onEdit(template)}>
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  )}
                  {canDelete && (
                    <Tooltip title="Eliminar">
                      <IconButton size="small" color="error" onClick={() => onDelete(template.id)}>
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination && (
        <TablePagination
          component="div"
          count={pagination.total || 0}
          page={(page || 1) - 1}
          onPageChange={handleChangePage}
          rowsPerPage={pagination.limit || 10}
          rowsPerPageOptions={[10]}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
          }
        />
      )}
    </Paper>
  );
};

export default TemplateTable;
